export { PaginationControls } from "./PaginationControls";

